import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import TimeSlotList from '../TimeSlotList/TimeSlotList';

import './TeacherAvailability.css';

class TeacherAvailability extends Component {
  render() {
    const {
      selectedDay: date,
      availableTimes: timeSlots,
      onSelectTimeSlot,
      selectedTimeSlot
    } = this.props;

    const morning = [];
    const afternoon = [];
    const evening = [];

    if (timeSlots) {
      timeSlots.forEach(slot => {
        slot.startDateTime = moment(slot.startDateTime);
        slot.endDateTime = moment(slot.endDateTime);
        if (slot.time < 60 * 12) {
          morning.push(slot);
        } else if (slot.time < 60 * 18) {
          afternoon.push(slot);
        } else {
          evening.push(slot);
        }
      });
    }

    const now = moment();

    return (
      <div className="TeacherAvailability">
        <h4> Select a Time </h4>

        <div className="row mt-3">
          <div className="col">
            <p className="mb-0">
              {' '}
              <strong> Date Selected: </strong> {date.format('MMM DD, YYYY')}{' '}
            </p>
            <p>
              {' '}
              <strong> Local Time: </strong> {now.format('LT')}{' '}
            </p>
          </div>
        </div>

        <div className="row">
          <TimeSlotList
            title="Morning"
            timeSlots={morning}
            onSelectTimeSlot={onSelectTimeSlot}
            selectedTimeSlot={selectedTimeSlot}
          />
          <TimeSlotList
            title="Afternoon"
            timeSlots={afternoon}
            onSelectTimeSlot={onSelectTimeSlot}
            selectedTimeSlot={selectedTimeSlot}
          />
          <TimeSlotList
            title="Evening"
            timeSlots={evening}
            onSelectTimeSlot={onSelectTimeSlot}
            selectedTimeSlot={selectedTimeSlot}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { selectedDay: state.filters.selectedDay };
}

export default connect(mapStateToProps)(TeacherAvailability);



// WEBPACK FOOTER //
// ./src/components/TeacherAvailability/TeacherAvailability.js